import React, { useRef } from "react";

const OtpInput = ({ length = 6, onOtpChange, disabled = false }) => {
  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (value.length > 1) {
      e.target.value = value.charAt(0);
    }

    if (onOtpChange) {
      const currentOtp = inputs.current.map((input) => input?.value || "").join("");
      onOtpChange(currentOtp);
    }

    if (value && index < length - 1) {
      inputs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim().slice(0, length);
    if (!pasteData) return;

    const chars = pasteData.split("");
    chars.forEach((char, index) => {
      if (inputs.current[index]) {
        inputs.current[index].value = char;
      }
    });

    if (onOtpChange) {
      onOtpChange(inputs.current.map((input) => input?.value || "").join(""));
    }

    const focusIndex = Math.min(chars.length, length - 1);
    inputs.current[focusIndex]?.focus();
  };

  return (
    <div className="d-flex justify-content-between gap-2 mb-4">
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          disabled={disabled}
          className="form-control custom-input otp-input"
          style={{
            width: "48px",
            height: "52px",
            textAlign: "center",
            fontSize: "1.25rem",
            fontWeight: "700",
            backgroundColor: "#225750",
            border: "1px solid rgba(111, 230, 184, 0.3)",
            borderRadius: "8px",
            color: "#FFFFFF",
          }}
          ref={(el) => (inputs.current[index] = el)}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          required
        />
      ))}
    </div>
  );
};

export default OtpInput;
